import React, { PureComponent } from 'react';

import { Container } from './guestsSelection.styles';
import { Notes } from './notes';
import { TicketsSelector } from './ticketsSelector';

export class GuestsSelection extends PureComponent {
  static propTypes = {};

  render() {
    return (
      <Container>
        <TicketsSelector />
        <Notes />
      </Container>
    );
  }
}
